import React from 'react';

import { peopleList, title, subTitle } from '@utils/staticText';
import Wrapper from '@media-spec/core/src/components/Wrapper';
import Header from '@media-spec/core/src/components/Header';
import Pages from '@containers/Pages';
import TextHeader from '@media-spec/core/src/components/TextHeader';
import { CardList } from '@media-spec/core/src/components/Card';
import Card from '@media-spec/core/src/components/Card';
import TextComponent from '@media-spec/core/src/components/TextComponent';
import classnames from 'classnames';

import * as commonClass from '@styles/common.module.css';
import * as S from './Landing.module.css';

import MainLogo from '@images/header_logo.svg';
import mainImage from '@images/main_img.png';
import mainImageRetina from '@images/main_img@2x.png';

import { useScroll } from '@root/hooks/useScroll/useScroll';

export const Landing: React.FunctionComponent = () => {
  const scrollY = useScroll();
  return (
    <Pages>
      <Header
        MainLogo={MainLogo}
        MainLogoTouch={MainLogo}
        bgColor="#fff"
        burgerColor="#005FF9"
        image={mainImage}
        bgMarginTop={90}
        imageRetina={mainImageRetina}
        logoWrapperClassName={classnames(
          S.logoWrapper,
          scrollY > 0 ? commonClass.headerShadow : ''
        )}
        imageHeight={400}
      />
      <Wrapper paddingTop>
        <section>
          <TextHeader
            className={classnames(
              commonClass.marginBottom40,
              commonClass.title
            )}
          >
            {title}
          </TextHeader>
          <TextComponent content={[subTitle]} />
        </section>
        <div id="personsId" className={S.persons}>
          <CardList className={S.cards}>
            {peopleList.map(({ avatar, title, subTitle, text }, index) => (
              <Card
                className={S.peopleCard}
                image={avatar}
                title={title}
                contacts={subTitle}
                text={text}
                link={`person/${index}`}
                key={index}
                imgClassName={S.peopleImg}
                titleClassName={S.personTitle}
                contactsClassName={S.personContacts}
              />
            ))}
          </CardList>
        </div>
      </Wrapper>
    </Pages>
  );
};
